import {useTranslation} from "react-i18next";
import IconBool from "components/IconBool";
import useCustomTranslation from "core/customTranslation";
import {translations} from "../translations";
import DateDisplay from "components/datetime/DateDisplay";

const TableImports = ({items, onClickRow}) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useCustomTranslation(translations);

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
        zIndex: 899,
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <th key="-1" style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        <input className="form-check-input" type="checkbox" value="all" />
                    </th>
                    {/* <th>Creada</th>
                    <th>Verificada</th>
                    <th>Importada</th>
                    <th>Finalizada</th>
                    <th>Avisos</th>
                    <th>Error</th>
                    <th>Tamaño</th> */}
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tc("table.created")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tt("common.email")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tc("table.verified")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tc("table.imported")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tc("table.finished")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tc("table.warnings")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tc("table.error")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {_Tc("table.size")}
                    </th>
                </tr>
            </thead>
            <tbody>
                {items ? (
                    items.map((item, index) => (
                        <tr key={index} onClick={onClickRow}>
                            <td>
                                <input type="checkbox" value={index} />
                            </td>
                            <td>
                                <DateDisplay date={item.created} title={true} />
                            </td>
                            <td>{item.email}</td>
                            <td>
                                <IconBool value={item.verified} />
                            </td>
                            <td>
                                <IconBool value={item.imported} />
                            </td>
                            <td>
                                <DateDisplay date={item.ended} title={true} />
                            </td>
                            <td>{item.result.warnings}</td>
                            <td>{item.error}</td>
                            <td>{item.size}</td>
                        </tr>
                    ))
                ) : (
                    <></>
                )}
            </tbody>
        </table>
    );
};

export default TableImports;
